/* WC Safety — Theme JS (global functions only) */

// ── MOBILE MENU ──
function toggleMobileMenu() {
  document.getElementById('mobileMenu').classList.toggle('open');
  document.getElementById('mobileOverlay').classList.toggle('show');
  document.body.style.overflow = document.getElementById('mobileMenu').classList.contains('open') ? 'hidden' : '';
}

function closeMobileMenu() {
  document.getElementById('mobileMenu').classList.remove('open');
  document.getElementById('mobileOverlay').classList.remove('show');
  document.body.style.overflow = '';
}

// ── HEADER SEARCH ──
function doHeaderSearch() {
  const q = document.getElementById('headerSearch').value.trim();
  if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
}

function doMobileSearch() {
  const q = document.getElementById('mobileSearch').value.trim();
  if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
}

// ── MEGA MENU ──
document.addEventListener('click', (e) => {
  if (!e.target.closest('.mega-nav-item') && !e.target.closest('.mega-dropdown')) {
    document.querySelectorAll('.mega-dropdown').forEach(d => {
      d.style.opacity = '';
      d.style.visibility = '';
    });
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeMobileMenu();
});

function updateMegaDropdownTop() {
  const header = document.getElementById('site-header');
  if (header) {
    const h = header.offsetHeight;
    document.querySelectorAll('.mega-dropdown').forEach(d => {
      d.style.top = h + 'px';
    });
  }
}

window.addEventListener('resize', updateMegaDropdownTop);
document.addEventListener('DOMContentLoaded', updateMegaDropdownTop);

// ── PRODUCT FILTER ──
function filterProducts(handle, btn) {
  document.querySelectorAll('.prods-filters .filter-btn').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');
  window.location.href = handle === 'all' ? '/collections/all' : '/collections/' + handle;
}

// ── RANKED PICKS ──
function selectRankedProduct(el) {
  document.querySelectorAll('.ranked-item').forEach(i => i.classList.remove('ri-active'));
  el.classList.add('ri-active');

  const f = document.getElementById('rankedFeature');
  if (!f) return;

  const emoji   = el.dataset.emoji    || '🛡️';
  const name    = el.dataset.name     || '';
  const price   = el.dataset.price    || '';
  const rating  = el.dataset.rating   || '4.8';
  const reviews = el.dataset.reviews  || '1,000+';
  const asin    = el.dataset.asin     || '';
  const desc    = el.dataset.longDesc || 'Expert-tested and WC Safety approved.';
  const cat     = el.querySelector('.rank-desc')?.textContent || 'Safety';

  const amazonUrl = asin
    ? 'https://www.amazon.com/dp/' + asin + '?tag=wcsafety04-20'
    : 'https://www.amazon.com/s?k=' + encodeURIComponent(name) + '&tag=wcsafety04-20';

  f.innerHTML =
    '<div class="ranked-feature-badge">Top Pick</div>' +
    '<span class="feat-emoji">' + emoji + '</span>' +
    '<div class="feat-name">' + name + '</div>' +
    '<div class="feat-desc">' + desc + '</div>' +
    '<div class="feat-specs">' +
      '<div class="feat-spec"><div class="feat-spec-l">Rating</div><div class="feat-spec-v">' + rating + '/5.0</div></div>' +
      '<div class="feat-spec"><div class="feat-spec-l">Reviews</div><div class="feat-spec-v">' + reviews + '</div></div>' +
      '<div class="feat-spec"><div class="feat-spec-l">Price</div><div class="feat-spec-v">' + price + '</div></div>' +
      '<div class="feat-spec"><div class="feat-spec-l">Category</div><div class="feat-spec-v">' + cat + '</div></div>' +
    '</div>' +
    '<a href="' + amazonUrl + '" target="_blank" rel="noopener sponsored" class="btn btn-orange">Check Price on Amazon →</a>';
}

// ── INIT ──
document.addEventListener('DOMContentLoaded', () => {
  // Header search enter key
  const hs = document.getElementById('headerSearch');
  if (hs) hs.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      const q = hs.value.trim();
      if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
    }
  });

  // Emoji z-index fix in product cards
  document.querySelectorAll('.prod-emoji').forEach(el => {
    el.style.position = 'relative';
    el.style.zIndex = '2';
    el.style.fontSize = '60px';
  });
});
